var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefreshCw02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Line/Arrows/refresh-cw-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M3 21C3 21 3.18198 22.2739 8.45406 27.5459C13.7261 32.818 22.2739 32.818 27.5459 27.5459C29.4139 25.678 30.62 23.3989 31.1643 21M3 21V30M3 21H12M33 15C33 15 32.818 13.7261 27.5459 8.45406C22.2739 3.18198 13.7261 3.18198 8.45406 8.45406C6.58615 10.322 5.38004 12.6011 4.83574 15M33 15V6M33 15H24",
    stroke: "#FBA013",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshCw02);
export default __webpack_public_path__ + "static/media/refresh-cw-02.f1bfab64e9713c75921e8a38f127d0f1.svg";
export { ForwardRef as ReactComponent };